import React from 'react';
import { Route } from 'react-router-dom';
import { AuthState, useAppState } from '../state/AppState';
import SignIn from '../components/SignIn';
import FourOhFour from './FourOhFour';
import Loading from './common/Loading';

export interface RedirectState {
  from: Location;
}

enum AuthRequirements {
  LoggedIn,
  Admin,
  PartyHost,
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({
  authRequirement,
  component,
  ...rest
}: React.ComponentProps<typeof Route> & { authRequirement: AuthRequirements }) {
  const { user, authState } = useAppState();

  if (authRequirement === AuthRequirements.LoggedIn) {
    if (authState === AuthState.LoggedOut) {
      return <Route {...rest} component={SignIn} />;
    } else if (authState === AuthState.FetchingUser) {
      return <Route {...rest} component={Loading} />;
    }
    return <Route {...rest} component={component} />;
  }

  if (authRequirement === AuthRequirements.Admin) {
    console.log(user?.isAdmin);
    return <Route {...rest} component={user?.isAdmin ? component : FourOhFour} />;
  }

  return <Route {...rest} component={FourOhFour} />;
}

export const LoggedInRoute = (props: React.ComponentProps<typeof Route>) => (
  <PrivateRoute authRequirement={AuthRequirements.LoggedIn} {...props} />
);

export const AdminRoute = (props: React.ComponentProps<typeof Route>) => (
  <PrivateRoute authRequirement={AuthRequirements.Admin} {...props} />
);

export const HostRoute = (props: React.ComponentProps<typeof Route>) => (
  <PrivateRoute authRequirement={AuthRequirements.PartyHost} {...props} />
);

export default PrivateRoute;
